import React from 'react';
import { useI18n } from '@whizz/react-i18n';
import { ButtonIcon } from '..';
import type { GoalProps } from './types';

interface Props {
  goal: GoalProps;
  cohortLabel?: string;
  handleEdit?: (data: GoalProps) => void;
}

const GoalCard = ({ goal, cohortLabel, handleEdit }: Props): JSX.Element => {
  const { translate: t } = useI18n();
  const metrics = goal.metrics.filter((metric): metric is string => !!metric);

  return (
    <article className={'flex flex-col bg-white border border-gray-200 rounded-default overflow-hidden'}>
      <div className={'flex justify-between items-start gap-2 px-4 py-3'}>
        <div className={'space-y-1'}>
          <h3 className={'font-semibold'}>{t(`pages.ADMIN.IMPACT_REPORTS.GOALS.${goal.goal_key}`)}</h3>
          {cohortLabel && <p className={'text-xs'}>{t('pages.IMPLEMENTATION_ACTION_STEPS.COHORT', { cohort: cohortLabel })}</p>}
        </div>
        {handleEdit && <ButtonIcon
          type={'button'}
          icon={'Edit'}
          asLink
          size={'sm'}
          aria-label={t('pages.IMPLEMENTATION_PLAN.EDIT_GOAL')}
          onClick={() => handleEdit(goal)}
        />}
      </div>
      {metrics.length > 0 && (
        <div className={'flex-1 bg-gray-50 border-t border-gray-200 px-4 py-3 space-y-2'}>
          <p className={'uppercase text-xs font-semibold tracking-wider'}>{t('pages.IMPLEMENTATION_PLAN.IMPACT_METRICS')}</p>
          <ul className={'space-y-2'}>
            {metrics.map((metric, index) => (
              <li key={index} className={'flex items-center gap-2 bg-white border border-gray-100 rounded-md px-3 py-2 text-xs'}>
                <span aria-hidden className={'w-1.5 h-1.5 rounded-full bg-header flex-shrink-0'} />
                {t(`pages.ADMIN.IMPACT_REPORTS.METRICS.${metric}`)}
              </li>
            ))}
          </ul>
        </div>
      )}
    </article>
  );
};

export { GoalCard };
